export const manifest = {
  screens: {
    scr_j7msgx: { name: "Hero", route: "/", state: {"section":"hero"}, position: {"x":160,"y":220} },
    scr_fq0iid: { name: "Beyond the Pour", route: "/", state: {"section":"intro"}, position: {"x":1560,"y":220} },
    scr_21xm6u: { name: "Services", route: "/", state: {"section":"services"}, position: {"x":2960,"y":220} },
    scr_8ss7fa: { name: "Beyond the Cocktails", route: "/", state: {"section":"beyond"}, position: {"x":7160,"y":220} },
    scr_vx4j3j: { name: "Onyx Showcase", route: "/", state: {"section":"showcase"}, position: {"x":4360,"y":220} },
    scr_xkefk4: { name: "Footer", route: "/", state: {"section":"footer"}, position: {"x":5760,"y":220} },
    scr_zlabja: { name: "Events Hero", route: "/events", state: {"section":"hero"}, position: {"x":160,"y":2200} },
    scr_8jhjeh: { name: "Events Location", route: "/events", state: {"section":"location"}, position: {"x":1560,"y":2200} },
    scr_rupq2u: { name: "Events Weddings", route: "/events", state: {"section":"weddings"}, position: {"x":2960,"y":2200} },
    scr_eo1183: { name: "Events Corporate", route: "/events", state: {"section":"corporate"}, position: {"x":4360,"y":2200} },
    scr_dyhhai: { name: "Events Milestones", route: "/events", state: {"section":"milestones"}, position: {"x":5760,"y":2200} },
    scr_94t95l: { name: "Blog", route: "/blog", position: {"x":160,"y":4180} },
    scr_bwvlkb: { name: "Book Us Now", route: "/book", position: {"x":160,"y":6160} },
    scr_m178qq: { name: "Services Page", route: "/services", position: {"x":160,"y":8140} },
    scr_7yo91t: { name: "About Us", route: "/about", position: {"x":160,"y":10120} },
    scr_j12hd4: { name: "See Our Works", route: "/works", position: {"x":160,"y":12100} },
    scr_53nnaa: { name: "Blog Details", route: "/blog/1", position: {"x":1560,"y":4180} },
  },
  sections: {
    sec_vers70: { name: "Landing Page", x: 0, y: 0, width: 8520, height: 1180 },
    sec_q89oao: { name: "Events Flow", x: 0, y: 1980, width: 7120, height: 1180 },
    sec_o1foc1: { name: "Blog", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_grrtxe: { name: "Booking Flow", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_qex3dq: { name: "Services Page", x: 0, y: 7920, width: 1520, height: 1180 },
    sec_g0mqkg: { name: "About", x: 0, y: 9900, width: 1520, height: 1180 },
    sec_2seu6y: { name: "Works", x: 0, y: 11880, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_vers70", children: [
      { kind: "screen", id: "scr_j7msgx" },
      { kind: "screen", id: "scr_fq0iid" },
      { kind: "screen", id: "scr_21xm6u" },
      { kind: "screen", id: "scr_vx4j3j" },
      { kind: "screen", id: "scr_xkefk4" },
      { kind: "screen", id: "scr_8ss7fa" },
    ] },
    { kind: "section", id: "sec_q89oao", children: [
      { kind: "screen", id: "scr_zlabja" },
      { kind: "screen", id: "scr_8jhjeh" },
      { kind: "screen", id: "scr_rupq2u" },
      { kind: "screen", id: "scr_eo1183" },
      { kind: "screen", id: "scr_dyhhai" },
    ] },
    { kind: "section", id: "sec_o1foc1", children: [
      { kind: "screen", id: "scr_94t95l" },
      { kind: "screen", id: "scr_53nnaa" },
    ] },
    { kind: "section", id: "sec_grrtxe", children: [
      { kind: "screen", id: "scr_bwvlkb" },
    ] },
    { kind: "section", id: "sec_qex3dq", children: [
      { kind: "screen", id: "scr_m178qq" },
    ] },
    { kind: "section", id: "sec_g0mqkg", children: [
      { kind: "screen", id: "scr_7yo91t" },
    ] },
    { kind: "section", id: "sec_2seu6y", children: [
      { kind: "screen", id: "scr_j12hd4" },
    ] },
  ],
}
